/* eslint-disable class-methods-use-this */
/* Null implementation legitimately doesn't need instance state */

import { ReviewService } from './ReviewService';

/**
 * Null implementation of ReviewService for web platform.
 * All methods are no-ops since app store reviews don't apply to web.
 */
export default class NullReviewService implements ReviewService {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor() {
    // No initialization needed for null implementation
  }

  async requestReview(): Promise<void> {
    // No-op: Web platform doesn't have app store reviews
  }

  async canRequestReview(): Promise<boolean> {
    // Always return false for web platform
    return false;
  }

  async resetForTesting(): Promise<void> {
    // No-op: Nothing to reset on web platform
  }
}
